import type { NonAgentJsonType } from '@bb/domain/dist/types/NonAgent';
import Axios from 'axios';

export type NonAgentSearchUser = Pick<
  NonAgentJsonType,
  'id' | 'org' | 'firstName' | 'lastName' | 'companyName' | 'type'
> & { score: number; fullName: string };

const searchDetails = async (nonAgentId: string) => {
  const { data } = await Axios.get<NonAgentJsonType>(
    '/nonagent/search/details',
    {
      params: { nonagent: { id: nonAgentId } },
    },
  );
  return data;
};

export default searchDetails;
